import { GoogleAnalytics as GoogleAnalyticsComponent } from '@next/third-parties/google';

export default function GoogleAnalytics() {
  if (process.env.NODE_ENV !== 'production') return null;

  const gaId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID;

  if (!gaId) return null;

  return <GoogleAnalyticsComponent gaId={gaId} />;
}
